export default __webpack_public_path__ + "static/media/IBM.3c094f91.jpg";